import React, { useState, useEffect, useRef } from "react";
import { useApp } from "../context/AppContext";
import { formatPrice } from "../utils/helpers";

export default function ChatModal({ chatId, onClose }) {
  const { currentUser, chats, sendMessage, markChatRead } = useApp();
  const [text, setText] = useState("");
  const bottomRef = useRef(null);

  // Siempre leer el chat actualizado directo del estado global
  const chat = chats.find(c => c.id === chatId);

  useEffect(() => {
    if (chat) markChatRead(chat.id);
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat?.messages?.length]);

  if (!chat) return null;

  const otherName = currentUser.id === chat.sellerId ? chat.buyerName : chat.sellerName;

const detectContactInfo = (text) => {
  const patterns = [
    /\b(\+?54)?[\s.-]?9?[\s.-]?(\d{2,4})[\s.-]?\d{4}[\s.-]?\d{4}\b/, // telefono AR
    /\b\d{6,}\b/,                    // numero largo
    /whatsapp|wsp|wasap|wa\.me/i,    // whatsapp
    /instagram|facebook|telegram|ig\b/i, // redes
    /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z]{2,}\b/i, // email
    /calle|avenida|av\.|pasaje|entre\s+.+\s+y/i, // direccion
  ];
  return patterns.some(p => p.test(text));
};

const handle = () => {
  if (!text.trim()) return;
  if (detectContactInfo(text)) {
    alert("⚠️ No esta permitido compartir numeros de telefono, direcciones ni datos de contacto por este medio.");
    return;
  }
  sendMessage(chat.id, text);
  setText("");
};

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.header}>
          <div>
            <p style={s.headerTitle}>Chat con {otherName}</p>
            <p style={s.headerSub}>{chat.productTitle} — {formatPrice(chat.productPrice)}</p>
          </div>
          <button style={s.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div style={s.messages}>
          {chat.messages.length === 0 && (
            <div style={s.emptyChat}>
              <span style={{fontSize:36}}>💬</span>
              <p>Empeza la conversacion sobre este producto</p>
            </div>
          )}
          {chat.messages.map(m => {
            const isMine = m.senderId === currentUser.id;
            return (
              <div key={m.id} style={{...s.msgRow, justifyContent: isMine ? "flex-end" : "flex-start"}}>
                {!isMine && <div style={s.msgAvatar}>{m.senderName.charAt(0)}</div>}
                <div style={{...s.bubble, ...(isMine ? s.bubbleMine : s.bubbleOther)}}>
                  <p style={s.msgText}>{m.text}</p>
                  <p style={s.msgTime}>
                    {new Date(m.date).toLocaleTimeString("es-AR", {hour:"2-digit",minute:"2-digit"})}
                    {isMine && <span style={{marginLeft:4}}>{m.read ? " ✓✓" : " ✓"}</span>}
                  </p>
                </div>
              </div>
            );
          })}
          <div ref={bottomRef} />
        </div>
<div style={s.warningBar}>
  🔒 Por seguridad de la comunidad, no compartas datos de contacto personales.
</div>
        <div style={s.inputRow}>
          <input
            style={s.input}
            placeholder="Escribi un mensaje..."
            value={text}
            onChange={e => setText(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handle()}
            autoFocus
          />
          <button style={{...s.sendBtn, background: text.trim() ? "#1D9E75" : "#ccc"}} onClick={handle} disabled={!text.trim()}>
            ➤
          </button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay:{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:16},
  modal:{background:"#fff",borderRadius:16,width:"100%",maxWidth:480,height:560,display:"flex",flexDirection:"column",overflow:"hidden"},
  header:{background:"#1D9E75",padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"},
  headerTitle:{color:"#fff",fontWeight:600,fontSize:15},
  headerSub:{color:"rgba(255,255,255,0.8)",fontSize:12,marginTop:2},
  closeBtn:{background:"rgba(255,255,255,0.2)",border:"none",color:"#fff",width:30,height:30,borderRadius:"50%",cursor:"pointer",fontSize:14},
  messages:{flex:1,overflowY:"auto",padding:"16px",display:"flex",flexDirection:"column",gap:10,background:"#f9f9f9"},
  emptyChat:{textAlign:"center",color:"#aaa",fontSize:13,margin:"auto",display:"flex",flexDirection:"column",alignItems:"center",gap:8},
  msgRow:{display:"flex",alignItems:"flex-end",gap:6},
  msgAvatar:{width:28,height:28,borderRadius:"50%",background:"#E1F5EE",color:"#0F6E56",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:600,flexShrink:0},
  bubble:{maxWidth:"75%",padding:"10px 14px",borderRadius:16,wordBreak:"break-word"},
  bubbleMine:{background:"#1D9E75",color:"#fff",borderBottomRightRadius:4},
  bubbleOther:{background:"#fff",color:"#111",border:"0.5px solid #e0e0e0",borderBottomLeftRadius:4},
  msgText:{fontSize:14,lineHeight:1.4},
  msgTime:{fontSize:10,marginTop:4,opacity:0.7,textAlign:"right"},
  inputRow:{display:"flex",gap:8,padding:"12px 16px",borderTop:"0.5px solid #e0e0e0",background:"#fff"},
  input:{flex:1,padding:"10px 14px",borderRadius:24,border:"0.5px solid #ddd",fontSize:14,outline:"none"},
  sendBtn:{background:"#1D9E75",color:"#fff",border:"none",borderRadius:"50%",width:42,height:42,fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0},
  warningBar:{background:"#fff8e1",padding:"8px 16px",fontSize:12,color:"#b7830a",textAlign:"center",borderBottom:"0.5px solid #f0c040"},
};
